export default {
  //this mirrors a [Flags] enum, hence the multiples
  None: 0,
  HeadOffice: 1,
  Finance: 2,
  SettingsAndRates: 4,
};
